import ApiClient from '@ecountabl/api-client'
import { SERVER } from './config'
import { log } from './utility'

const client = new ApiClient({
  endpoint: SERVER
})

type InitApiParams = {
  onTokenError?: (err: string) => void
  onTokenUpdate?: (token: string) => void
  getAccessToken: () => Promise<string | null>
}

export const initApi = ({ onTokenError, onTokenUpdate, getAccessToken }: InitApiParams): void => {
  client.onTokenError = async (err: string): Promise<void> => {
    if (onTokenError) {
      onTokenError(err)
    } else {
      log.error(err, { tags: { message: 'unhandled token error' } })
    }
  }

  client.onTokenUpdate = async (token): Promise<void> => {
    if (onTokenUpdate) {
      onTokenUpdate(token)
    }
  }

  client.asyncGetToken = async (): Promise<string | null> => {
    const token = await getAccessToken()
    if (!token) {
      return null
    }
    return token
  }
}

export default client
